export default "__VITE_ASSET__4b49M_mt__"